<template xmlns="http://www.w3.org/1999/html">
  <div class="my_font_size_layer">
    <my_radio
      :titleWidth="titleWidth"
      :title="title"
      :option="option"
      :defaultIsShow="defaultIsShow"
      :hiddenIsShow="hiddenIsShow"
      :selfIsShow="selfIsShow"
      :defaultIsDisabled="defaultIsDisabled"
      :hiddenIsDisabled="hiddenIsDisabled"
      :selfIsDisabled="selfIsDisabled"
      :selectValue.sync="radio_value"
    >
      <div slot="pull_down_control">
        <my_select
          :isGroup="hasCustomFont"
          :type="type"
          @change="onSelectFont"
          :titleWidth="titleWidth"
          :title="fontFamilyTitle"
          :options="fontFamilyOptions"
          :value.sync="font_family"
          v-if="font_family !== undefined "
        >
        <template #history>
          <el-option-group
          v-if="fontFamilyHistory.length"
          :label="$t('components_my_color_picker_index_2300')">
          <el-option
            v-for="item in fontFamilyHistory"
            :key="item.value + '-history'"
            :label="item.label"
            :value="item.value"
            :title="item.label">
            <svg v-if="$store.state.options.fontFamilySystem[item.value]" class="font_svg"><use :xlink:href="$store.state.options.fontFamilySystem[item.value]"></use></svg>
            <span v-else :class="item.label" v-text="item.label"></span>
          </el-option>
          <li class="el-select-group__title custom_font">{{$t('components_my_font_family_index_2309')}}</li>
        </el-option-group>
        </template>
      </my_select>
        <select_font_size
          :type="type"
          :titleWidth="titleWidth"
          :title="fontSizeTitle"
          :options="fontSizeOption"
          :value.sync="font_size"
          v-if="font_size !== undefined"
        ></select_font_size>
        <p class="setOne">
          <my_color
            :type="type"
            :titleWidth="titleWidth"
            :title="colorTitle"
            :color.sync="color_value"
            v-if="color_value !==undefined"
            :linear_gradient.sync='linear_gradient'
            :pattern.sync='base_pattern'
          ></my_color>
          <my_color
            :type="type"
            :titleWidth="secondColorTitleWidth"
            :title="selectColorTitle"
            :color.sync="select_color"
            v-if="select_color !==undefined"
            class="select_color"
            :linear_gradient.sync='seLinear_gradient'
            :pattern.sync='se_pattern'
          ></my_color>
        </p>
        <span
          class="line"
          v-if="lineIsShow == 'true'"
        >
          ------------------------------------------------------------------------
        </span>
        <p class="setOne">
          <my_text_biu
            :type="type"
            :titleWidth="titleWidth"
            :title="textBiuTitle"
            :fsWeight.sync="fs_weight"
            :fsItalics.sync="fs_italics"
            :fsUnderline.sync="fs_underline"
            v-if="fs_weight !== undefined || fs_italics !== undefined || fs_underline !== undefined "
          ></my_text_biu>
          <my_text_align
            :titleWidth="titleWidth"
            :textAlign.sync="text_align"
            v-if="text_align !== undefined"
          ></my_text_align>
        </p>
      </div>
    </my_radio>
  </div>
</template>

<script>
import i18n from '../../language/index'

import select_font_size from './components/select_font_size'
import {createFont, getFontStyle } from '@/api/app.js'
import style_list_config from '../../base/style_list_config'

export default {
  name: 'my_font_size_index',
  components: {
    select_font_size
  },
  props: {
    secondColorTitleWidth: {
      type: String,
      default: '86'
    },
    fontSizeWidth: {
      type: String,
      default: '40'
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    type: { // 组件的标题
      type: String,
      default: 'two_level'
    },
    title: { // 组件的标题
      type: String,
      default: i18n.t('widgets_basic_classification_edit_468')
    },
    fontFamilyTitle: {
      type: String,
      default: i18n.t('components_my_font_family_index_2307')
    },
    fontFamily: {
      type: String
    },
    fontSize: {
      type: Number
    },
    fontSizeTitle: {
      type: String,
      default: i18n.t('components_my_font_size_index_2311')
    },
    colorTitle: {
      type: String,
      default: i18n.t('view_back_top_edit_99')
    },
    selectColorTitle: {
      type: String,
      default: i18n.t('widgets_basic_button_edit_446')
    },
    textBiuTitle: {
      type: String,
      default: i18n.t('widgets_basic_button_edit_449')
    },
    fsWeight: {
      type: String,
    },
    fsItalics: {
      type: String,
    },
    fsUnderline: {
      type: String,
    },
    radioValue: {
      type: String
    },
    pattern: {},
    sePattern: {},
    linearGradient: {},
    seLinearGradient: {},
    colorValue: {
      type: String
    },
    selectColor: {
      type: String
    },
    textAlign: {
      type: String
    },
    lineIsShow: {
      type: String,
      default: 'true'
    },
    option: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultIsShow: {
      type: String,
      default: 'true'
    },
    hiddenIsShow: {
      type: String,
      default: 'true'
    },
    selfIsShow: {
      type: String,
      default: 'true'
    },
    defaultIsDisabled: { // 默认设置是否禁用
      type: String,
      default: 'false'
    },
    hiddenIsDisabled: { // 隐藏设置是否禁用
      type: String,
      default: 'false'
    },
    selfIsDisabled: { // 自定义设置是否禁用
      type: String,
      default: 'false'
    },
    fontSizeOption: {
      type: Array,
      default: function () {
        return this.$store.state.options.fontSize
      }
    },
    hasCustomFont: {
      type: Boolean,
      default: false
    },
    customFont: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      radio_value: this.radioValue,
      font_family: this.fontFamily,
      font_size: this.fontSize,
      color_value: this.colorValue,
      select_color: this.selectColor,
      fs_weight: this.fsWeight,
      fs_italics: this.fsItalics,
      fs_underline: this.fsUnderline,
      text_align: this.textAlign,
      base_pattern: this.pattern,
      se_pattern: this.sePattern,
      linear_gradient: this.linearGradient,
      seLinear_gradient: this.seLinearGradient,
      fontFamilyHistory: [],
      // customFontModuleList: ['basic_text_rich_type', 'basic_icon_combination']
    }
  },
  computed: {
    fontFamilyOptions() {
      if (!this.hasCustomFont) {

        const fonts =['en-us','de-de','es-es','in-id','uz-uz','ms-my','sw-ke'];
        // 德语,西班牙语，印尼语，乌兹别克语，马来语，斯瓦希里语
        if(fonts.includes(this.$store.state.app.language)){
          // 新增免费字体
          const fontFamilyFree = this.$store.state.options.fontFamilyFree.filter(item => { return item.lang === 'en' })
          const fontFamilyZh = this.$store.state.options.fontFamilyZh.filter(item => { return item.lang === 'zh' })
          const fontFamilyZh_EN = this.$store.state.options.fontFamilyZh.filter(item => { return item.lang === 'en' })
          return [...fontFamilyZh_EN, ...fontFamilyFree, ...fontFamilyZh]
        }else{
          return this.$store.state.options.fontFamilyZh
        }
        
      } else {
        return [{
          label: i18n.t('components_my_font_family_index_2309'),
          options: this.$store.state.options.fontFamilyZh
        }, {
          label: i18n.t('components_my_font_family_index_2310'),
          options: this.$store.state.options.fontFamilyFree
        }]
      }
    }
  },
  watch: {
    radio_value(val) { // 数据双向绑定
      this.$emit('update:radioValue', val)
    },
    font_family(val) {
      let font = {};
      let fontList = [...this.$store.state.options.fontFamilyZh, ...this.$store.state.options.fontFamilyFree]
      let fontFamilyZhKeys = this.$store.state.options.fontFamilyZh.map(item => item.value)
      if(!isNaN(parseFloat(val)) && isFinite(val) || fontFamilyZhKeys.includes(val)){
        font = fontList.find(f => f.value === val)
      }else{
        font = fontList.find(f => f.label === val)
      }
      if (!font.isSystem) {
        // this.createFont()
        this.getFontStyle(val)
       this.$emit('update:fontFamily', font.label)
      } else {
        this.$emit('update:customFont', {
          name: '',
          url: ''
        });
        // 数据双向绑定
        this.$emit('update:fontFamily', val)
      }
    },
    font_size(val) { // 数据双向绑定
      this.$emit('update:fontSize', val)
    },
    color_value(val) { // 数据双向绑定
      this.$emit('update:colorValue', val)
    },
    select_color(val) { // 数据双向绑定
      this.$emit('update:selectColor', val)
    },
    fs_weight(val) { // 数据双向绑定
      this.$emit('update:fsWeight', val)
    },
    fs_italics(val) { // 数据双向绑定
      this.$emit('update:fsItalics', val)
    },
    fs_underline(val) { // 数据双向绑定
      this.$emit('update:fsUnderline', val)
    },
    text_align(val) { // 数据双向绑定
      this.$emit('update:textAlign', val)
    },
    base_pattern(val) { // 数据双向绑定
      this.$emit('update:pattern', val)
    },
    se_pattern(val) { // 数据双向绑定
      this.$emit('update:sePattern', val)
    },
    linear_gradient(val) { // 数据双向绑定
      this.$emit('update:linearGradient', val)
    },
    seLinear_gradient(val) { // 数据双向绑定
      this.$emit('update:seLinearGradient', val)
    },
    'seLinearGradient'(val) { // 数据双向绑定
      this.seLinear_gradient = val
    },
    'linearGradient'(val) { // 数据双向绑定
      this.linear_gradient = val
    },
    'sePattern'(val) { // 数据双向绑定
      this.se_pattern = val
    },
    'pattern'(val) { // 数据双向绑定
      this.base_pattern = val
    },
    'radioValue'(val) { // 数据双向绑定
      this.radio_value = val
    },
    'fontFamily'(val) { // 数据双向绑定
      this.font_family = val
    },
    'fontSize'(val) { // 数据双向绑定
      this.font_size = val
    },
    'colorValue'(val) { // 数据双向绑定
      this.color_value = val
    },
    'selectColor'(val) { // 数据双向绑定
      this.select_color = val
    },
    'fsWeight'(val) { // 数据双向绑定
      this.fs_weight = val
    },
    'fsItalics'(val) { // 数据双向绑定
      this.fs_italics = val
    },
    'fsUnderline'(val) { // 数据双向绑定
      this.fs_underline = val
    },
    'textAlign'(val) { // 数据双向绑定
      this.text_align = val
    },
  },
  methods: {
    getFontStyle(val) {
      let fontStyle = {}
      getFontStyle({font:val}).then((res) => {
        if(res && res.data)
           fontStyle = {
            name: val,
            url: res.data
          }
        this.$utils.insertStyle(fontStyle)
      })
    },
    createFont() {
      let widetsId = this.$store.state.app.module_Data.widgets_id
      createFont({
        originFontId: Number(this.font_family),
        keyword: $(`#u${widetsId}`).text(),
        pageName: this.$store.state.app.now_page
      }).then((res) => {
        let font = {
          name: res.data.font_face,
          url: res.data.fonts_file_url
        }
        this.$utils.insertStyle(font)
        this.$emit('update:customFont', font);
      })
    },
    onSelectFont(fontValue) {
      let font = {};
      let fontList = [...this.$store.state.options.fontFamilyZh, ...this.$store.state.options.fontFamilyFree]
      let fontFamilyZhKeys = this.$store.state.options.fontFamilyZh.map(item => item.value)
      if (!isNaN(parseFloat(fontValue)) && isFinite(fontValue) || fontFamilyZhKeys.includes(fontValue)) {
        font = fontList.find(f => f.value === fontValue)
      } else {
        font = fontList.find(f => f.label === fontValue)
      }
      this.fontFamilyHistory.unshift(font)
      let fontNameList = this.fontFamilyHistory.map(font => font.value)
      fontNameList = [...new Set(fontNameList)]
      this.fontFamilyHistory = fontNameList.map(name => {
        return fontList.find(item => item.value === name)
      })
      if (this.fontFamilyHistory.length > 4) {
        this.fontFamilyHistory.pop()
      }
      localStorage.setItem('fontFamilyHistory', JSON.stringify(this.fontFamilyHistory))
    },
  },
  mounted() {
  },
  created() {    
    let fontFamilyHistory = localStorage.getItem('fontFamilyHistory')
    if (fontFamilyHistory) {
      this.fontFamilyHistory = JSON.parse(fontFamilyHistory)
      this.fontFamilyHistory = this.fontFamilyHistory.filter(item => { return item != null })
      this.fontFamilyHistory.map(e => parseInt(e.value) > 12)
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
@import "src/css/components/special_fonts";
.setOne {
  display: flex;
  justify-content: flex-start;
}

.line {
  display: inline-block;
  max-width: 80%;
  height: 18px;
  overflow: hidden;
  letter-spacing: 2px;
  color: #e3e2e8;
}

.my_color_layer,
.my_text_biu_layer {
  /deep/ .set_two_level {
    margin-bottom: 0 !important;
  }
}

.select_color {
  /deep/ .set_two_level .title {
    width: 50px;
  }
}

/deep/ .custom_font{
  margin: 24px 24px 0px 24px;
  border-top: 1px solid #E4E7ED;
  padding-left: 0px;
  padding-top: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/my_font_size/index.vue